import { Component, Input } from '@angular/core';
import { TituloReceberFilter } from '../../filter';

@Component({
    selector: 'sgt-titulo-receber-dashboard',
    templateUrl: './titulo-receber-dashboard.component.html',
    styleUrls: ['titulo-receber-dashboard.component.less']
})
export class TituloReceberDashboardComponent {
    @Input() filter: TituloReceberFilter;

    load() {
        //
    }
}
